module.exports = __webpack_public_path__ + "img/savings-bubble-3.ddbd4e68.png";